export default "__VITE_ASSET__CruqjgZK__"